var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-file-item',{attrs:{"localeFile":_vm.locale,"backgroundImage":_vm.backgroundImage,"size":_vm.size,"simpleButton":_vm.simpleButton,"circle":_vm.circle},on:{"change":_vm.handleChangeFile}})}
var staticRenderFns = []

export { render, staticRenderFns }